import { STORAGE_KEYS } from "@shared/constants/storageKeys"

/**
 * Persistent dedupe set of lactometer measurements already attached to a
 * workout — shared by the background auto-import runner and the manual import
 * view so a measurement is never attached twice (and the manual view shows
 * auto-imported rows as already done).
 */

const MAX_KEYS = 500

export interface KeyedMeasurement {
  id: string
  timestamp: number
}

/** Stable key for a measurement (`id:timestamp` avoids cross-device id clashes). */
export function importKeyFor(measurement: KeyedMeasurement): string {
  return `${measurement.id}:${measurement.timestamp}`
}

export function loadImportedKeys(): Set<string> {
  try {
    const raw = localStorage.getItem(STORAGE_KEYS.LACTATE_AUTO_IMPORTED_KEYS)
    if (!raw) return new Set()
    const parsed = JSON.parse(raw) as unknown
    return new Set(Array.isArray(parsed) ? (parsed as string[]) : [])
  } catch {
    return new Set()
  }
}

export function persistImportedKeys(keys: Set<string>): void {
  try {
    // Cap the persisted set so it can't grow without bound.
    localStorage.setItem(STORAGE_KEYS.LACTATE_AUTO_IMPORTED_KEYS, JSON.stringify(Array.from(keys).slice(-MAX_KEYS)))
  } catch {
    /* storage full / unavailable — dedupe degrades to in-session only */
  }
}
